import type { JiraConfigurableNavigationItem, MenuItemConfigData } from '../../types.tsx';

export const getProductItemsData = (
	navItems: JiraConfigurableNavigationItem[],
): MenuItemConfigData[] =>
	navItems.map((item) => {
		return {
			menuId: item.menuId,
			visible: item.isVisible,
		};
	});
